import $i from "~/i18n";
import * as actions from "./actions";
import * as mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({}),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/monitoring/index.js